module.exports = __webpack_public_path__ + "static/img/13.9e84aec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/13.png
// module id = N8cB
// module chunks = 0